import { Box } from '@mui/material';
export const renderCellByDelimiter = (params) => {
  const value = params.value || '';

  const [beforeAt, afterAt] = value.split('@');

  return (
      <Box>
        <Box>{beforeAt}</Box>
        {afterAt && <Box>@{afterAt}</Box>}
      </Box>
  );
};
